export const DRAWER_PLACEMENTS = {
    top: 'top',
    end: 'end',
    bottom: 'bottom',
    start: 'start',
};
